import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';
import {
  ServicioOrdenamientosService,
  ParametrosOrdenamientosEntity,
  FiltrosOrdenGeneralEntity
} from 'src/app/services/servicio-ordenamientos.service';

@Component({
  selector: 'app-header-orden-general',
  templateUrl: './header-orden-general.component.html',
  styleUrls: ['./header-orden-general.component.css']
})
export class HeaderOrdenGeneralComponent implements OnInit {

  @Input() parametros: ParametrosOrdenamientosEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;

  filtros: FiltrosOrdenGeneralEntity = {} as FiltrosOrdenGeneralEntity;
  profesionales: SelectItem[] = [];
  dxAdicionales: SelectItem[] = [];

  constructor(private ordenamientosService: ServicioOrdenamientosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();

    this.filtros = {
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment().format('YYYY-MM-DD'),
      profesionales: [],
      dxAdicionales: []
    }
  }

  ngOnInit() {
    this.getProfesionales();
  }

  async getProfesionales() {
    let response = await this.ordenamientosService.getProfesionalesOrdenesGeneral(this.parametros);

    response.subscribe((data: any) => {
      if (data && data['#result-set-1'].length > 0) {
        data['#result-set-1'].forEach(profesional => {
          this.profesionales.push({
            label: profesional['dscrpcn'],
            value: profesional['unco']
          });
          this.filtros.profesionales.push(profesional['unco']);
        });
      }
      this.getDiagnosticosAdicionales();
    }, (error) => {
      console.log('Error HeaderOrdenServiciosComponent.getProfesionales()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  async getDiagnosticosAdicionales() {
    try {
      const response = await this.ordenamientosService.getDiagnosticosAdicionales(this.parametros);
      response.subscribe((data: any) => {
        if (data) {
          data['dxAdicionales'].forEach(dx => {
            this.dxAdicionales.push({
              label: dx['descripcion'],
              value: dx['codigo']
            });
            this.filtros.dxAdicionales.push(dx['codigo']);
          })
        }
      }, (err) => {
        console.error('Error HeaderOrdenGeneralComponent.getDiagnosticosAdicionales()', err);
        this.errorGenerado.emit('Error al obtener los diagnosticos adicionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch HeaderOrdenGeneralComponent.getDiagnosticosAdicionales()', e);
      this.errorGenerado.emit('Error grave al obtener los diagnosticos adicionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  onGenerar() {
    const { fechaInicio, fechaFin, profesionales } = this.filtros;
    if (fechaInicio.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Inicial</strong> debe ser una fecha válida.');
    } else if (fechaFin.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Final</strong> debe ser una fecha válida.');
    } else if (profesionales.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Profesional</strong>.');
    } else {
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-ordenes-servicios').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
